<script lang="ts">
  let props = $props()
  let { responses = [], scores = [] }: { responses: any; scores: any } = props

  const valuesResponseCount =
    responses["value1"].length +
    responses["value2"].length +
    responses["value3"].length +
    responses["value4"].length +
    responses["value5"].length

  const goalsResponseCount =
    responses["goal1"].length +
    responses["goal2"].length +
    responses["goal3"].length
</script>

<p class="text-xl lg:text-xl text-grey-800 text-left font-bold mt-8">
  What is the company's Brand Purpose?
</p>

<div class="mt-6 border border-gray-400 shadow">
  <div class="grid grid-cols-6 border-b border-gray-400">
    <div
      class="col-span-2 bg-indigo-700 text-white p-2 flex items-center font-bold justify-center"
    >
      Total Number of Responses:
    </div>
    <div
      class="p-2 text-lg lg:text-xl flex items-center justify-center font-bold"
    >
      {responses[`q2`].length}
    </div>
    <div
      class="col-span-2 bg-indigo-700 text-white p-2 flex font-bold items-center justify-center"
    >
      LWP Alignment Score:
    </div>
    <div
      class="p-2 text-lg lg:text-xl flex items-center justify-center font-bold"
    >
      {scores[2]}%
    </div>
  </div>
  <div class="p-3">
    <div class="text-sm font-medium text-gray-900 grid grid-cols-3 gap-2">
      {#each responses[`q2`].sort() as response, i}
        <div class="border border-gray-200">
          <div class="text-center p-2 bg-indigo-200 border-b border-gray-200">
            Response #{i + 1}
          </div>
          <div class="text-center p-2">
            {#if response == "undefined" || response == "" || response == "null"}
              <span class="p-2 text-gray-600 text-sm italic">N/A</span>
            {:else}
              <span class="p-2">{response}</span>
            {/if}
          </div>
        </div>
      {/each}
    </div>
  </div>
</div>

<p class="text-xl lg:text-xl text-grey-800 text-left font-bold mt-12">
  What are the top five Values of the company from most to least important?
</p>

<div class="mt-6 border border-gray-400 shadow">
  <div class="grid grid-cols-6 border-b border-gray-400">
    <div
      class="col-span-2 bg-indigo-700 text-white p-2 flex items-center font-bold justify-center"
    >
      Total Number of Responses:
    </div>
    <div
      class="p-2 text-lg lg:text-xl flex items-center justify-center font-bold"
    >
      {valuesResponseCount}
    </div>
    <div
      class="col-span-2 bg-indigo-700 text-white p-2 flex font-bold items-center justify-center"
    >
      LWP Alignment Score:
    </div>
    <div
      class="p-2 text-lg lg:text-xl flex items-center justify-center font-bold"
    >
      {scores[4]}%
    </div>
  </div>

  <div class="text-sm font-medium text-gray-900">
    {#each [1, 2, 3, 4, 5] as value}
      <div
        class="p-2 border-b border-gray-300 text-sm font-medium text-gray-900 sm:pl-0 flex gap-3 items-center"
      >
        <p class="text-lg font-bold px-4 whitespace-nowrap">Value #{value}</p>
        <div
          class="flex-grow grid grid-cols-3 gap-3 p-2 border border-gray-200"
        >
          {#each responses[`value${value}`].sort() as response, i}
            <div class="border border-gray-200">
              <div
                class="text-center p-2 bg-indigo-200 border-b border-gray-200"
              >
                Response #{i + 1}
              </div>
              <div class="text-center p-2">
                {#if response == "undefined" || response == "" || response == "null"}
                  <span class="p-2 text-gray-600 text-sm italic">N/A</span>
                {:else}
                  <span class="p-2">{response}</span>
                {/if}
              </div>
            </div>
          {/each}
        </div>
      </div>
    {/each}
  </div>
</div>

<p class="text-xl lg:text-xl text-grey-800 text-left font-bold mt-12">
  What is the company's Blue Sky Vision?
</p>

<div class="mt-6 border border-gray-400 shadow">
  <div class="grid grid-cols-6 border-b border-gray-400">
    <div
      class="col-span-2 bg-indigo-700 text-white p-2 flex items-center font-bold justify-center"
    >
      Total Number of Responses:
    </div>
    <div
      class="p-2 text-lg lg:text-xl flex items-center justify-center font-bold"
    >
      {responses[`q3`].length}
    </div>
    <div
      class="col-span-2 bg-indigo-700 text-white p-2 flex font-bold items-center justify-center"
    >
      LWP Alignment Score:
    </div>
    <div
      class="p-2 text-lg lg:text-xl flex items-center justify-center font-bold"
    >
      {scores[3]}%
    </div>
  </div>

  <div class="p-3">
    <div class="text-sm font-medium text-gray-900 grid grid-cols-3 gap-2">
      {#each responses[`q3`].sort() as response, i}
        <div class="border border-gray-200">
          <div class="text-center p-2 bg-indigo-200 border-b border-gray-200">
            Response #{i + 1}
          </div>
          <div class="text-center p-2">
            {#if response == "undefined" || response == "" || response == "null"}
              <span class="p-2 text-gray-600 text-sm italic">N/A</span>
            {:else}
              <span class="p-2">{response}</span>
            {/if}
          </div>
        </div>
      {/each}
    </div>
  </div>
</div>

<p class="text-xl lg:text-xl text-grey-800 text-left font-bold mt-12">
  What are your team's top 3 Annual Goals this year?
</p>

<div class="mt-6 border border-gray-400 shadow">
  <div class="grid grid-cols-6 border-b border-gray-400">
    <div
      class="col-span-2 bg-indigo-700 text-white p-2 flex items-center font-bold justify-center"
    >
      Total Number of Responses:
    </div>
    <div
      class="p-2 text-lg lg:text-xl flex items-center justify-center font-bold"
    >
      {goalsResponseCount}
    </div>
    <div
      class="col-span-2 bg-indigo-700 text-white p-2 flex font-bold items-center justify-center"
    >
      LWP Alignment Score:
    </div>
    <div
      class="p-2 text-lg lg:text-xl flex items-center justify-center font-bold"
    >
      {scores[5]}%
    </div>
  </div>

  <div class="text-sm font-medium text-gray-900">
    {#each [1, 2, 3] as value}
      <div
        class="p-2 border-b border-gray-300 text-sm font-medium text-gray-900 sm:pl-0 flex gap-3 items-center"
      >
        <p class="text-lg font-bold px-4 whitespace-nowrap">Goal #{value}</p>
        <div
          class="flex-grow grid grid-cols-3 gap-3 p-3 border border-gray-200"
        >
          {#each responses[`goal${value}`].sort() as response, i}
            <div class="border border-gray-200">
              <div
                class="text-center p-2 bg-indigo-200 border-b border-gray-200"
              >
                Response #{i + 1}
              </div>
              <div class="text-center p-2">
                {#if response == "undefined" || response == "" || response == "null"}
                  <span class="p-2 text-gray-600 text-sm italic">N/A</span>
                {:else}
                  <span class="p-2">{response}</span>
                {/if}
              </div>
            </div>
          {/each}
        </div>
      </div>
    {/each}
  </div>
</div>
